/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Doc_Terms_TitleInputs */

const en_checkout_doc_terms_title = /** @type {(inputs: Checkout_Doc_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking Terms`)
};

/**
* | output |
* | --- |
* | "Booking Terms" |
*
* @param {Checkout_Doc_Terms_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_doc_terms_title = /** @type {((inputs?: Checkout_Doc_Terms_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Doc_Terms_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_doc_terms_title(inputs)
});